import * as FavoritesActions from './favorites.actions';
import { createReducer, on } from '@ngrx/store';
import { FavoriteStop, FavoriteLocation, FavoriteTicket, FavoritePreference } from '../favorites.model';
import { FavoriteSchedule } from '../favorites.model';

export interface FavoritesState {
    favoriteStopLoading: boolean;
    favoriteStops: FavoriteStop[];
    favoriteLocations: FavoriteLocation[];
    favoriteTickets: FavoriteTicket[];
    favoriteTicketsLoading: boolean;
    favoritePreference: FavoritePreference;
    favoriteSchedules: FavoriteSchedule[];
}

export const FAVORITES_FEATURE_KEY = 'Favorites';

export const favoritesInitialState: FavoritesState = {
    favoriteStopLoading: false,
    favoriteStops: [],
    favoriteLocations: [],
    favoriteTickets: [],
    favoriteTicketsLoading: false,
    favoritePreference: null,
    favoriteSchedules: []
};

export const favoritesReducer = createReducer(
    favoritesInitialState,

    on(FavoritesActions.getFavoriteStops, (state) => ({
        ...state,
        favoriteStopLoading: true
    })),

    on(FavoritesActions.getFavoriteStopsSuccess, (state, { favoriteStops }) => ({
        ...state,
        favoriteStops,
        favoriteStopLoading: false
    })),

    on(FavoritesActions.getFavoriteStopsFailed, (state) => ({
        ...state,
        favoriteStopLoading: false
    })),

    on(FavoritesActions.addFavoriteStopSuccess, (state, { favoriteStop }) => ({
        ...state,
        favoriteStops: [...state.favoriteStops, favoriteStop]
    })),

    on(FavoritesActions.addFavoriteStopsFromLocalstorageSuccess, (state, { favoriteStops }) => ({
        ...state,
        favoriteStops: [...state.favoriteStops, ...favoriteStops]
    })),

    on(FavoritesActions.updateFavoriteStopSuccess, (state, { favoriteStop }) => ({
        ...state,
        favoriteStops: state.favoriteStops.map((stop) => (stop.stopId === favoriteStop.stopId ? favoriteStop : stop))
    })),

    on(FavoritesActions.deleteFavoriteStopSuccess, (state, { stopId }) => ({
        ...state,
        favoriteStops: state.favoriteStops.filter((stop) => stop.stopId !== stopId)
    })),

    on(FavoritesActions.deleteFavoriteStopsSuccess, (state, { stopIds }) => ({
        ...state,
        favoriteStops: state.favoriteStops.filter((stop) => !stopIds.find((id) => stop.stopId === id))
    })),

    on(FavoritesActions.getFavoriteLocationsSuccess, (state, { favoriteLocations }) => ({
        ...state,
        favoriteLocations
    })),

    on(FavoritesActions.addFavoriteLocationSuccess, (state, { favoriteLocation }) => ({
        ...state,
        favoriteLocations: [...state.favoriteLocations, favoriteLocation]
    })),

    on(FavoritesActions.addFavoriteLocationsFromLocalstorageSuccess, (state, { favoriteLocations }) => ({
        ...state,
        favoriteLocations: [...state.favoriteLocations, ...favoriteLocations]
    })),

    on(FavoritesActions.updateFavoriteLocationSuccess, (state, { favoriteLocation }) => ({
        ...state,
        favoriteLocations: state.favoriteLocations.map((location) =>
            location.id === favoriteLocation.id ? favoriteLocation : location
        )
    })),

    on(FavoritesActions.deleteFavoriteLocationSuccess, (state, { favoriteLocation }) => ({
        ...state,
        favoriteLocations: state.favoriteLocations.filter(
            (l) => !(favoriteLocation.latitude === l.latitude && favoriteLocation.longitude === l.longitude)
        )
    })),

    on(FavoritesActions.deleteFavoriteLocationsSuccess, (state, { favoriteLocations }) => ({
        ...state,
        favoriteLocations: state.favoriteLocations.filter(
            (l) =>
                !favoriteLocations.find(
                    (location) => location.latitude === l.latitude && location.longitude === l.longitude
                )
        )
    })),

    on(FavoritesActions.getFavoriteTickets, (state) => ({
        ...state,
        favoriteTicketsLoading: true
    })),

    on(FavoritesActions.getFavoriteTicketsSuccess, (state, { favoriteTickets }) => ({
        ...state,
        favoriteTickets,
        favoriteTicketsLoading: false
    })),

    on(FavoritesActions.getFavoriteTicketsFailed, (state) => ({
        ...state,
        favoriteTicketsLoading: false
    })),

    on(FavoritesActions.addFavoriteTicketSuccess, (state, { favoriteTicket }) => ({
        ...state,
        favoriteTickets: [...state.favoriteTickets, favoriteTicket]
    })),

    on(FavoritesActions.deleteFavoriteTicketSuccess, (state, { productId }) => ({
        ...state,
        favoriteTickets: state.favoriteTickets.filter((t) => Number(t.productId) !== Number(productId))
    })),

    on(FavoritesActions.getFavoritePreferenceSuccess, (state, { favoritePreference }) => ({
        ...state,
        favoritePreference
    })),

    on(FavoritesActions.addFavoritePreferenceSuccess, (state, { favoritePreference }) => ({
        ...state,
        favoritePreference: favoritePreference
    })),

    on(FavoritesActions.deleteFavoritePreferenceSuccess, (state) => ({
        ...state,
        favoritePreference: null
    })),

    on(FavoritesActions.getFavoriteSchedulesSuccess, (state, { favoriteSchedules }) => ({
        ...state,
        favoriteSchedules: favoriteSchedules
    })),

    on(FavoritesActions.addFavoriteScheduleSuccess, (state, { favoriteSchedule }) => ({
        ...state,
        favoriteSchedules: [...state.favoriteSchedules, favoriteSchedule]
    })),

    on(FavoritesActions.deleteFavoriteSchedulesSuccess, (state, { favoriteSchedules }) => ({
        ...state,
        favoriteSchedules: state.favoriteSchedules.filter(
            (el) =>
                !favoriteSchedules.find(
                    (schedule) =>
                        (el.stopId === schedule.stopId && el.routeId === schedule.routeId) || el?.id === schedule?.id
                )
        )
    })),
    on(FavoritesActions.addFavoriteSchedulesFromLocalstorageSuccess, (state, { favoriteSchedules }) => ({
        ...state,
        favoriteSchedules: [...state.favoriteSchedules, ...favoriteSchedules]
    }))
);
